import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { RadioButtonCheckedTwoTone } from "@material-ui/icons";
import BookingGetters from "../../../store/onlineBooking/getters";
import { AppStandardMultiSelectCheckBox } from "../../UI/AppMultipleSelection";
import { BookingApi } from "../../../API/Apis/BookingApi";
import { useSearchParams } from "react-router-dom";
import "../../../App.css";

function getParentOrigin() {
  try {
    if (
      window.location.ancestorOrigins &&
      window.location.ancestorOrigins.length > 0
    ) {
      return window.location.ancestorOrigins[0];
    }
    if (document.referrer) {
      return new URL(document.referrer).origin;
    }
  } catch (error) {
    console.error("Error in getParentOrigin:", error);
    return "";
  }
}

const parentOrigin = getParentOrigin();
const allowedOrigins = new Set([
  "https://mbrent.mercedes-benz.it",
  "https://bookingmerfina.mbrent.mercedes-benz.it",
  "https://mbrent.mercedes-benz.it/congaratulation",
  "https://merfinatestbooking.myrent.it",
  "https://mauroc147.myrent.it",
]);

const targetOrigin =
  parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";

const scrollToTop = () => {
  window.parent.postMessage(
    {
      event_id: "scrollToTop",
    },
    targetOrigin
  );
};
function BookingDetailsRecep({
  paymentPage = "true",
  allPaymentMethods,
  selectedFields,
  updatePaymentMethod,
  selectedPaymentMethod,
  isPrivacyPolicyChecked,
  isTermsCondnChecked,
  totalResDetailsHeight,
  activeStep,
}) {
  function requestParentResize() {
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: {
          iframeHeight: totalResDetailsHeight,
        },
      },
      targetOrigin
    );
  }

  useEffect(() => {
    if (!isSmallScreen) {
      requestParentResize();
      scrollToTop();
    }
  }, []);
  const showTermCondition = false;
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  const toogleForPrivacyPolicy = () => {
    const newPrivacyAccepted = !showPrivacyPolicy;
    setShowPrivacyPolicy(newPrivacyAccepted);
  };
  const isDesktopScreen = window.innerWidth >= 1220;
  const isSmallScreen = window.innerWidth <= 768;
  const termCondition = "";
  const bookingInfo = BookingGetters.getBookingDetails();
  const [searchParams] = useSearchParams();
  const dealerIdParams = searchParams.get("dealerId") || "";
  const idSupplier =
    bookingInfo?.pickUpLocationDetails?.dealerId || dealerIdParams;
  const [termsConditionUrl, setTermsConditionUrl] = useState("#");
  const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState("#");
  localStorage.setItem("idSupplier", idSupplier);
  const fetchTermsAndPrivacyUrls = async () => {
    try {
      const response = await BookingApi.getPrivacyAndTerms(idSupplier);
      const termsUrl =
        response?.data?.termsConditionFile || "https://default-link.com";
      const privacyUrl =
        response?.data?.privacyfileUrl || "https://default-link.com";
      setTermsConditionUrl(termsUrl);
      setPrivacyPolicyUrl(privacyUrl);
    } catch (error) {
      console.error("Error fetching URLs:", error);
    }
  };

  useEffect(() => {
    if (activeStep == 3) {
      fetchTermsAndPrivacyUrls();
    }
  }, [activeStep]);

  const paymentOptions = allPaymentMethods
    ? Object.keys(allPaymentMethods).map((e) => (
        <PaymentDiv
          key={e}
          payType={e}
          selectedPaymentMethod={selectedPaymentMethod}
          updatePaymentMethod={updatePaymentMethod}
          isSmallScreen={isSmallScreen}
        />
      ))
    : null;

  const istabletScreen = window.innerWidth >= 768 && window.innerWidth <= 1220;
  return (
    <>
      <div
        style={
          isDesktopScreen
            ? {
                marginTop: "64px",
                width: "100%",
                maxWidth: "1280px",
              }
            : istabletScreen
            ? { marginBottom: "152px" }
            : {}
        }
      >
        <div>
          <h2
            style={{
              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
              color: "#1E1E1E",
              fontSize: !isSmallScreen ? "32px" : "24px",
              marginLeft: isSmallScreen ? "26px" : "",
            }}
          >
            {t("Reservation Details")}
          </h2>
        </div>
        <hr
          style={{
            marginTop: !isSmallScreen ? "17px" : "",
            border: "none",
            borderTop: "1px solid #000000",
          }}
        />
        <div
          className="flex flex-col md:flex-row"
          style={{
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            borderRadius: "7px", // Apply borderRadius to the container
            border: "1px solid #B3B3B3", // General border
            height: "217px",
            margin: !isSmallScreen ? "" : "10px",
            marginTop: !isSmallScreen ? "41px" : "10px",
          }}
        >
          <div
            style={{
              width: !isSmallScreen ? "50%" : "100%",
            }}
          >
            <span>
              <div
                style={{
                  color: "#000000",
                  fontSize: "24px",
                  fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                  marginTop: "28px",
                  marginLeft: !isSmallScreen ? "55px" : "30px",
                }}
              >
                {t("Pick-up Date and Time")}
              </div>
              <div
                style={{
                  color: "#000000",
                  fontSize: "15px",
                  fontFamily: "MBCorpoSText-Regular-Web-new",
                  marginTop: "12px",
                  marginLeft: !isSmallScreen ? "55px" : "30px",
                }}
              >
                {formatDateTime(bookingInfo.pickUpDateAndTime)}
              </div>
            </span>
            <span>
              <div
                style={{
                  color: "#000000",
                  fontSize: "24px",
                  fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                  marginTop: "11px",
                  marginLeft: !isSmallScreen ? "55px" : "30px",
                }}
              >
                {t("Drop-off Date and Time")}
              </div>
              <div
                style={{
                  color: "#000000",
                  fontSize: "15px",
                  fontFamily: "MBCorpoSText-Regular-Web-new",
                  marginTop: "12px",
                  marginLeft: !isSmallScreen ? "55px" : "30px",
                }}
              >
                {formatDateTime(bookingInfo.dropOffDateAndTime)}
              </div>
            </span>
          </div>
          {isDesktopScreen && (
            <div
              style={{
                width: !isSmallScreen ? "50%" : "100%",
              }}
            >
              <div
                style={{
                  color: "#000000",
                  marginTop: !isSmallScreen ? "0%" : "10%",
                  marginLeft: "7%",
                  paddingTop: isSmallScreen ? "0px" : "80px",
                }}
              >
                <div>
                  <span
                    style={{
                      fontSize: !isSmallScreen ? "20px" : "18px",
                      fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                      color: "#000000",
                      fontWeight: "100px",
                    }}
                  >
                    {bookingInfo?.pickUpLocationDetails?.dealerName}
                  </span>
                  <br />
                  <span
                    style={{
                      fontSize: !isSmallScreen ? "" : "14px",
                      fontFamily: "MBCorpoSText-CondLight-Web",
                      display: "inline-block",
                      color: "#000000",
                      fontWeight: "bold",
                    }}
                  >
                    {bookingInfo?.pickUpLocationDetails?.locationDescription}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
        <div
          className="flex flex-col md:flex-row"
          style={{
            margin: !isSmallScreen ? "" : "10px",
          }}
        >
          <div
            style={{
              border: "1px solid #B3B3B3",
              borderRight: !isSmallScreen ? "none" : "1px solid #B3B3B3",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              borderRadius: !isSmallScreen
                ? "7px 0px 0px 7px"
                : "7px 7px 0px 0px",
              height: !isSmallScreen ? "217px" : "200px",
              display: "flex",
              flexDirection: !isSmallScreen ? "row" : "column",
              marginTop: "3%",
              width: !isSmallScreen ? "50%" : "100%",
              flex: 1, // Ensure the first div grows to fill available space
            }}
          >
            <div
              style={{
                marginTop: !isSmallScreen ? "30px" : "15px",
              }}
            >
              <ExtrasAndInsurance
                selectedFields={selectedFields}
                isSmallScreen={isSmallScreen}
              />
            </div>
          </div>

          <div
            style={{
              height: !isSmallScreen ? "217px" : "175px",
              width: !isSmallScreen ? "50%" : "100%",
              marginTop: !isSmallScreen ? "3%" : "",
              backgroundColor: "#e5e5e5",
              border: "1px solid #B3B3B3",
              borderLeft: !isSmallScreen ? "none" : "1px solid #B3B3B3",
              boxShadow: isSmallScreen ? "rgba(0, 0, 0, 0.1) 0px 2px 5px" : "",
              borderRadius: !isSmallScreen
                ? "0px 7px 7px 0px"
                : "0px 0px 7px 7px",
            }}
          >
            <div
              style={{
                color: "#000000",
                marginTop: !isSmallScreen ? "0%" : "10%",
                marginLeft: "7%",
                paddingTop: isSmallScreen ? "0px" : "67px",
              }}
            >
              <div>
                <span
                  style={{
                    fontSize: "20px",
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                  }}
                >
                  {t("Trust our team!")}
                </span>
                <br />
                <span
                  style={{
                    fontSize: "15px",
                    fontFamily: "MBCorpoSText-CondLight-Web",
                    display: "inline-block",
                    textAlign: "left",
                  }}
                >
                  {t(
                    "Let our operators at your selected Mercedes-Benz dealer guide you through your choice of extras and additional cover."
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>

        {paymentPage == "true" ? (
          <div
            style={{
              height: !isSmallScreen ? "217px" : "200px",
              boxShadow: "0 2px 2px #B3B3B3, 0 2px 2px #B3B3B3",
              margin: isSmallScreen ? "10px" : "",
              marginTop: !isSmallScreen ? "41px" : "10px",
              border: "1px solid #B3B3B3",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              borderRadius: "7px",
              marginBottom: !isSmallScreen ? "" : "46px",
            }}
          >
            <div
              style={{
                color: "#000000",
                fontSize: "24px",
                fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                marginTop: !isSmallScreen ? "44px" : "30px",
                marginLeft: !isSmallScreen ? "55px" : "30px",
              }}
            >
              {t("Payment Method")}
            </div>
            {paymentOptions}
          </div>
        ) : (
          <div
            style={{
              height: !isSmallScreen ? "217px" : "200px",
              border: "1px solid #B3B3B3",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              borderRadius: "7px",
              margin: !isSmallScreen ? "" : "10px",
              marginBottom: isSmallScreen ? "20px" : "",
              marginTop: !isSmallScreen ? "41px" : "20px",
            }}
          >
            <div
              style={{
                color: "#000000",
                fontSize: "24px",
                fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                marginTop: !isSmallScreen ? "44px" : "40px",
                marginLeft: !isSmallScreen ? "55px" : "30px",
              }}
            >
              {t("terms & condition")}
            </div>
            <div
              style={{
                color: "#000000",
                fontSize: "16px",
                fontFamily: "MBCorpoSText-Regular-Web-new",
                marginLeft: !isSmallScreen ? "55px" : "30px",
              }}
            >
              <AppStandardMultiSelectCheckBox
                required={true}
                color={"primary"}
                onChange={(selectedValue) => isTermsCondnChecked(selectedValue)}
                options={[
                  {
                    label: (
                      <>
                        <span
                          style={{
                            fontFamily: "MBCorpoSText-CondLight-Web",
                            fontSize: "15px",
                          }}
                        >
                          {t("I declare to accept and agree to the_terms")}
                        </span>{" "}
                        <a
                          href={termsConditionUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#0078D6",
                            fontFamily: "MBCorpoSText-CondLight-Web",
                            fontSize: "15px",
                            textDecoration: "underline",
                          }}
                          className="text-[primary] text-md "
                        >
                          {t("terms & condition")}
                        </a>
                      </>
                    ),
                    value: "I have read and agree to the rental conditions",
                  },
                ]}
              />
            </div>
            <div
              style={{
                color: "#000000",
                fontSize: "16px",
                fontFamily: "MBCorpoSText-Regular-Web-new",
                marginTop: "-14px",
                marginLeft: !isSmallScreen ? "55px" : "30px",
              }}
            >
              <AppStandardMultiSelectCheckBox
                required={true}
                color={"primary"}
                onChange={(selectedValue) =>
                  isPrivacyPolicyChecked(selectedValue)
                }
                options={[
                  {
                    label: (
                      <>
                        <span
                          style={{
                            fontFamily: "MBCorpoSText-CondLight-Web",
                            fontSize: "15px",
                          }}
                        >
                          {t("I declare to accept and agree to the_privacy")}
                        </span>{" "}
                        <a
                          href={privacyPolicyUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#0078D6",
                            fontFamily: "MBCorpoSText-CondLight-Web",
                            fontSize: "15px",
                            textDecoration: "underline",
                          }}
                          onClick={toogleForPrivacyPolicy}
                          className="text-[primary] text-md capitalize"
                        >
                          {t("privacy policy")}
                        </a>
                      </>
                    ),
                    value: "I have read and agree to the rental conditions",
                  },
                ]}
              />
            </div>
          </div>
        )}
        {showTermCondition && (
          <span className="text-[#707070] text-sm text-left whitespace-pre-line">
            <div>{termCondition}</div>
          </span>
        )}
      </div>
    </>
  );
}
function ExtrasAndInsurance({ selectedFields, isSmallScreen }) {
  return (
    <>
      <ExtraSection
        selectedFields={selectedFields}
        isSmallScreen={isSmallScreen}
      />
      {/* Insurance section */}
      <InsuranceSection
        selectedFields={selectedFields}
        isSmallScreen={isSmallScreen}
      />
    </>
  );
}

function ExtraOptionsList({ options, isSmallScreen }) {
  return (
    <div className="text-left">
      <div style={{ marginTop: isSmallScreen ? "-8%" : "" }}>
        <div
          className="flex flex-wrap"
          style={{
            fontSize: "15px",
            marginTop: isSmallScreen && "30px",
          }}
        >
          {Object.entries(options).map(([key, value]) => (
            <div key={key} className="ml-[31px] md:ml-[55px]">
              <div className="flex justify-between rounded-md">
                <span>{value?.details}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function ExtraSection({ selectedFields, isSmallScreen }) {
  const hasExtras = Object.values(selectedFields?.options || {}).length > 0;

  return (
    <>
      <div
        style={{
          color: "#000000",
          fontSize: "24px",
          fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
          marginTop: "11px",
          marginLeft: !isSmallScreen ? "55px" : "30px",
        }}
      >
        {t("Extra")}
      </div>
      <span
        style={{
          color: "#000000",
          fontSize: "15px",
          fontFamily: "MBCorpoSText-Regular-Web-new",
        }}
      >
        {hasExtras ? (
          <ExtraOptionsList
            options={selectedFields.options}
            isSmallScreen={isSmallScreen}
          />
        ) : (
          <span
            className="whitespace-nowrap"
            style={{
              fontSize: "15px",
              marginLeft: !isSmallScreen ? "56px" : "8%",
            }}
          >
            {t("No extras selected")}
          </span>
        )}
      </span>
    </>
  );
}

const textStyle = {
  color: "#000000",
  fontSize: "15px",
  fontFamily: "MBCorpoSText-Regular-Web-new",
};

const containerStyle = (isSmallScreen) => ({
  fontSize: "24px",
  color: "#000000",
  fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
  marginLeft: !isSmallScreen ? "55px" : "30px",
});

function InsuranceDetails({ insurance, isSmallScreen }) {
  return (
    <div
      className="text-left text-black"
      style={{ marginBottom: isSmallScreen ? "8%" : "" }}
    >
      <div>
        <span
          className="pt-1 pb-1"
          style={{ ...textStyle, marginLeft: !isSmallScreen ? "56px" : "8%" }}
        >
          {insurance.details}
        </span>
        <span style={{ fontSize: "small" }}>{insurance.name}</span>
      </div>
    </div>
  );
}

function InsuranceSection({ selectedFields, isSmallScreen }) {
  return (
    <>
      <div style={containerStyle(isSmallScreen)}>{t("Insurance")}</div>
      <span style={textStyle}>
        {selectedFields?.insurance ? (
          <InsuranceDetails
            insurance={selectedFields.insurance}
            isSmallScreen={isSmallScreen}
          />
        ) : (
          <span
            style={{ ...textStyle, marginLeft: !isSmallScreen ? "56px" : "8%" }}
          >
            {t("No insurance selected")}
          </span>
        )}
      </span>
    </>
  );
}

function PaymentDiv({
  payType,
  selectedPaymentMethod,
  updatePaymentMethod,
  isSmallScreen,
}) {
  return (
    <div
      className="paymentDiv-pament"
      style={{
        marginLeft: isSmallScreen ? "27px" : "50px",
      }}
    >
      <>
        {payType.toLowerCase() == "paypal" && (
          <div
            className="paymentDiv-paypal"
            style={{
              width: isSmallScreen ? "185px" : "173px",
            }}
          >
            <div
              className="flex flex-row"
              onClick={() => {
                updatePaymentMethod("paypal");
              }}
              style={{
                marginLeft: "16px",
                marginTop: "24px",
                justifyContent: "space-between",
              }}
            >
              <img
                src="/assets/icons/paypalLogo.png"
                className="h-[25px] w-[34px]"
                alt={"paypal"}
              />
              <RadioButtonCheckedTwoTone
                style={{
                  color:
                    selectedPaymentMethod === "paypal"
                      ? "#00ADEF"
                      : "rgba(0, 173, 239, 0.21)",
                  fontSize: "xx-large",
                  marginRight: "9px",
                }}
              />
            </div>
          </div>
        )}
      </>
    </div>
  );
}

function formatDateTime(input: string | number | Date): string {
  const date = new Date(input);
  const datePart = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const timePart = `${date.getHours().toString().padStart(2, "0")}:${date
    .getMinutes()
    .toString()
    .padStart(2, "0")}`;

  return `${datePart} ${timePart}`;
}

export { BookingDetailsRecep };
